import React, { Fragment, useContext } from "react";

import DashPage from '../dash/DashPage';
import useWindowSize from "../../utility/useWindowSize";
import position from "../../styles/position";

import logo from "../../assets/logo.jpg";
import styles from "./styles";
import AnimateFrom from "../../components/animations/AnimateFrom";
import VersionInfo from "../login/VersionInfo";
import { useTranslation } from "react-i18next";
import { SessionContext } from "../../utility/useSession";


const HomePage = () => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const windowSize = useWindowSize();

    let factor = windowSize.width / 800;

    if (factor > 1) {
        factor = 1;
    }

    return (<DashPage absoluteChildren={
        <Fragment>
            <div style={{ ...position.absoluteFill, overflow: "hidden", transition: "all 0.2s ease-in-out 0s" }}>
                <div style={{ ...styles.centeredBox, "zoom": factor }}>
                    <div style={styles.centeredBoxInner}>

                        <AnimateFrom delay={1} duration={0.8} style={{
                            opacity: 0,
                            zoom: 0,
                            y: -100,
                            rotateZ: 360
                        }}>
                            <img style={styles.logo} src={logo} />
                        </AnimateFrom>

                        <AnimateFrom delay={1} style={{
                            opacity: 0,
                            zoom: 0,
                            y: -500,
                        }}>
                            <div><span style={styles.title}>
                                {t("welcome.title")}
                            </span></div>
                            <div><span style={styles.message}>{t(
                                "welcome.message",
                                {
                                    environment: session.options.environment !== 'production' ? session.options.environment : '',
                                }
                            )}</span></div>
                        </AnimateFrom>
                    </div>
                </div>
            </div>

            <div style={{ position: "fixed", right: 20, bottom: 10, color: "dimgray", opacity: 0.5 }}>
                <VersionInfo></VersionInfo>
            </div>
        </Fragment>
    }></DashPage >);
};

export default HomePage;
